export default {
    CF_NAME:1, 
    CF_GENRE:2, 
    CF_DEADLINE:3, 
    CF_STATUS:4, 
  };